export const categories = [
    {
        id: 1,
        name: "Hombre",
        image: "https://picsum.photos/id/665/1500/500/",
        description: "lorem ipsum lorem ipsum lorem ipsum"
    },
    {
        id: 2,
        name: "Mujer",
        image: "https://picsum.photos/id/777/1500/500/",
        description: "lorem ipsum lorem ipsum lorem ipsum"
    },
    {
        id: 3,
        name: "Niños",
        image: "https://picsum.photos/id/838/1500/500/",
        description: "lorem ipsum lorem ipsum lorem ipsum"
    },

]
